import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { parseISO, format } from 'date-fns';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const SECTIONS = {
  luka: {
    name: 'Luka',
    color: 'bg-blue-50 text-blue-900',
    accent: 'text-blue-600'
  },
  klara: {
    name: 'Klara',
    color: 'bg-rose-50 text-rose-900',
    accent: 'text-rose-600'
  },
  family: {
    name: 'Family',
    color: 'bg-emerald-50 text-emerald-900',
    accent: 'text-emerald-600'
  },
  trips: {
    name: 'Trips',
    color: 'bg-amber-50 text-amber-900',
    accent: 'text-amber-600'
  },
};

/**
 * Formats a date string safely without timezone shifting
 */
export const formatDateSafe = (dateStr, formatStr = 'MMMM d, yyyy') => {
  if (!dateStr) return '';
  // parseISO respects the date as written (YYYY-MM-DD) without shifting for local timezone
  return format(parseISO(dateStr), formatStr);
};

/**
 * Enhanced Image Fixer: Converts Google Drive/Dropbox links to direct image URLs
 */
export const fixImageUrl = (url) => {
  if (!url) return 'https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=800';
  let f = url.trim();

  // Google Drive Fix
  if (f.includes('drive.google.com')) {
    const id = f.match(/\/d\/([^/]+)/) || f.match(/id=([^&]+)/);
    if (id && id[1]) return `https://lh3.googleusercontent.com/d/${id[1]}`;
  }

  // Dropbox Fix
  if (f.includes('dropbox.com')) {
    return f.replace('www.dropbox.com', 'dl.dropboxusercontent.com').replace('?dl=0', '');
  }

  return f;
};